
import axios from '../../functions/axios';
import { useState, useEffect } from 'react';
import editButton from '../../assets/images/editButton.png';
import { useNavigate } from "react-router-dom";
import style from './Driver.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';
import { Grid } from '@mui/material';


function DriversList() {
  const [apiData, setApiData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const getDriversData = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get(`/driver`);
      setApiData(response);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditDriver = (driver) => {
    navigate('/editDriver', { state: { driver } })
  };

  const handleFilterDrivers = (searchQuery) => setSearchQuery(searchQuery.trim().toLowerCase());

  useEffect(getDriversData, [user]);

  return (
    <>
      <div className={style.menu}>
        <div className={style.filter}>
          <p>Wyszukaj Kierowcę:</p>
          <input type='text' className='form-control' placeholder='Imię i nazwisko' onChange={(e) => handleFilterDrivers(e.target.value)}></input>
        </div>
        <button className='btn btn-default' onClick={navigate.bind(null, '/addDriver')}>Dodaj kierowcę</button>
      </div>
      <Grid container spacing={2} className={style.container}>
        {
          apiData
            .filter((driver) => {
              if (searchQuery === '')
                return true;
              return driver.name?.toLowerCase().includes(searchQuery);
            })
            .sort((...args) => {
              const [a, b] = args.map(driver => driver.name);
              return a.localeCompare(b, 'pl', { sensitivity: 'base' });
            })
            .map((driver, index) =>(
              <Grid sx={6} item className={style.driver} key={index}>
                <p className={style.driverName}>{driver.name}</p>
                <p className={style.driverPhone}>{driver.phoneNumber}</p>
                <img className={style.editButton} src={editButton} onClick={handleEditDriver.bind(null, driver)} />
              </Grid>
          ))
        }
      </Grid>
    </>
  );
}

export default DriversList;
